import { render, staticRenderFns } from "./SwitchRequirement.vue?vue&type=template&id=5aafbc18&scoped=true&"
import script from "./SwitchRequirement.vue?vue&type=script&lang=js&"
export * from "./SwitchRequirement.vue?vue&type=script&lang=js&"
import style0 from "./SwitchRequirement.vue?vue&type=style&index=0&id=5aafbc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aafbc18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VContainer})
